import React, { useState } from "react";
import { getChallenge } from "../../services/ChallengeService";
import "../../styles/TruthOrDareApp.css"; // estilos customizados

const TruthOrDareApp: React.FC = () => {
  const [type, setType] = useState<string | null>(null);
  const [level, setLevel] = useState<number | null>(null);
  const [challenge, setChallenge] = useState<any>(null);
  const [loading, setLoading] = useState(false);

  const handleTypeSelect = async (selectedType: "truth" | "dare") => {
    setType(selectedType);

    if (level) {
      setLoading(true);
      try {
        const data = await getChallenge(selectedType, level);
        setChallenge(data);
      } catch (err) {
        setChallenge({ error: "Erro ao buscar desafio" });
      } finally {
        setLoading(false);
      }
    }
  };

  const handleLevelSelect = async (selectedLevel: number) => {
    if (!type) return;
    setLevel(selectedLevel);
    setLoading(true);

    try {
      const data = await getChallenge(type, selectedLevel);
      setChallenge(data);
    } catch (err) {
      setChallenge({ error: "Erro ao buscar desafio" });
    } finally {
      setLoading(false);
    }
  };

  const handleReset = () => {
    setType(null);
    setChallenge(null);
  };

  return <div></div>;
    // <div className="truth-dare-bg">
    //   <Container className="d-flex flex-column align-items-center mt-5">
    //     {/* Seleção do tipo */}
    //     {!type && (
    //       <Row className="g-4">
    //         {[
    //           { label: "🔥 Verdade", value: "truth" },
    //           { label: "😈 Desafio", value: "dare" },
    //         ].map((item) => (
    //           <Col md={6} key={item.value} className="d-flex">
    //             <Card
    //               className="glass-card text-center p-4 cursor-pointer h-100 w-100"
    //               onClick={() => handleTypeSelect(item.value as "truth" | "dare")}
    //             >
    //               <Card.Body className="d-flex align-items-center justify-content-center">
    //                 <Card.Title className="sexy-text">{item.label}</Card.Title>
    //               </Card.Body>
    //             </Card>
    //           </Col>
    //         ))}
    //       </Row>
    //     )}

    //     {/* Seleção do nível */}
    //     {type && !level && (
    //       <Row className="g-4 mt-4">
    //         {[1, 2, 3, 4].map((lvl) => (
    //           <Col md={3} key={lvl}>
    //             <Card
    //               className="glass-card text-center p-4 cursor-pointer"
    //               onClick={() => handleLevelSelect(lvl)}
    //             >
    //               <Card.Body>
    //                 <Card.Title className="sexy-text">
    //                   Nível {lvl}
    //                 </Card.Title>
    //               </Card.Body>
    //             </Card>
    //           </Col>
    //         ))}
    //       </Row>
    //     )}

    //     {/* Loading */}
    //     {loading && (
    //       <div className="mt-4">
    //         <Spinner animation="border" role="status" variant="light">
    //           <span className="visually-hidden">Carregando...</span>
    //         </Spinner>
    //       </div>
    //     )}

    //     {/* Resultado */}
    //     {challenge && (
    //       <Card className="glass-card mt-4 p-4 w-75 text-center">
    //         <Card.Body>
    //           {challenge.error ? (
    //             <p className="text-danger">{challenge.error}</p>
    //           ) : (
    //             <>
    //               <Card.Title className="sexy-text">
    //                 {challenge.type === "truth" ? "🔥 Verdade" : "😈 Desafio"}
    //               </Card.Title>
    //               <Card.Text className="text-light">
    //                 {challenge.text}
    //               </Card.Text>
    //             </>
    //           )}
    //           <Button variant="danger" className="mt-3" onClick={handleReset}>
    //             Voltar
    //           </Button>
    //         </Card.Body>
    //       </Card>
    //     )}
    //   </Container>
    // </div>
  // );
};

export default TruthOrDareApp;
